import actions from "./actions";

const initState = {
  invoicesData: [],
  loading: false,
};

export default function invoicesReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_INVOICES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesData: action.invoicesData,
        loading: false,
      };
    default:
      return state;
  }
}
